import axios from "axios";
import { Formik } from "formik";
import * as React from "react";
import { useCallback, useState } from "react";
import { RouteComponentProps } from "react-router-dom";
import { CustomError } from "../Models/CustomError";
import { ValidationError } from "../Models/ValidationErrors";
import { isCustomError } from "../Utils";

interface IProps extends RouteComponentProps {}

export const Register = (props: IProps): JSX.Element => {
    const [reqErrors, setReqErrors] = useState<CustomError>();
    const { history } = props;
    const onFormikSubmit = useCallback(async (values, { setSubmitting }) => {
        console.log(values);

        //register
        try {
            await axios.post(
                process.env.REACT_APP_API_URL + "/api/v1/identity/register",
                { email: values.email, password: values.pwd }
            );

            //redirect to home
            history?.push("/");
        } catch (error) {
            if(isCustomError(error)){
                setReqErrors(error);
            }
        }

        setSubmitting(false);
    }, [history]);

    const onFormikValidate = useCallback((values) => {
        const errors: ValidationError = {
            email: "",
            pwd: "",
        };

        if (!values.email) {
            errors.email = "Required";
        } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
        ) {
            errors.email = "Invalid email address";
        }

        if (!values.pwd) {
            errors.pwd = "Required";
        }

        if (errors.email !== "" || errors.pwd !== "") return errors;

        return {};
    }, []);
    return (
        <div className="row justify-content-center">
            <div className="col-4">
                <Formik
                    initialValues={{ email: "", pwd: "" }}
                    onSubmit={onFormikSubmit}
                    validate={onFormikValidate}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                    }) => (
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>Email address:</label>
                                <input
                                    className="form-control"
                                    required
                                    type="email"
                                    placeholder="email"
                                    id="email"
                                    name="email"
                                    onChange={handleChange("email")}
                                    onBlur={handleBlur}
                                    value={values.email}
                                />
                                {touched.email && (
                                    <small className="form-text text-muted">
                                        {errors.email}
                                    </small>
                                )}
                            </div>

                            <div className="form-group">
                                <label>Password:</label>
                                <input
                                    className="form-control"
                                    required
                                    type="password"
                                    placeholder="password"
                                    id="pwd"
                                    name="pwd"
                                    onChange={handleChange("pwd")}
                                    onBlur={handleBlur}
                                    value={values.pwd}
                                />
                                {touched.pwd && (
                                    <small className="form-text text-muted">
                                        {errors.pwd}
                                    </small>
                                )}
                            </div>

                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={isSubmitting}
                            >
                                Register
                            </button>

                            {reqErrors?.errors.map(
                                (error: string) => (
                                    <small className="form-text text-muted">
                                        {error}
                                    </small>
                                )
                            )}
                        </form>
                    )}
                </Formik>
            </div>
        </div>
    );
};
